import { Box, Typography } from "@mui/material";
import { autovioColors } from "./backofficeTheme";

export function Badge2({ badgeContent, className }: { badgeContent: string | number; className?: string }) {
  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: "6px",
        minWidth: "16px",
        height: "16px",
        borderRadius: "999px",
        backgroundColor: autovioColors.red,
        color: "#fff",
        boxSizing: "border-box",
      }}
    >
      <Typography sx={{ fontSize: "10px", lineHeight: 1 }}>{badgeContent}</Typography>
    </Box>
  );
}
